/* Bea Joyas — Motion (port fiel de motion.jsx): cursor de joyería, tilt 3D + glare, magnetic, scroll progress, parallax.
   Vanilla JS. Respeta prefers-reduced-motion y solo activa cursor/tilt/magnetic en dispositivos hover+fine. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function canHover() { return window.matchMedia('(hover:hover) and (pointer:fine)').matches; }

  /* Cursor custom (anillo + punto) QUITADO a pedido del dueño (8-jul-2026):
     queda el cursor NATIVO del sistema + solo la estela de brillos al mover. */
  var css = '' +
    '.cur-layer{position:fixed;inset:0;z-index:9998;pointer-events:none;transition:opacity .3s;}' +
    '.cur-spark{position:fixed;z-index:9998;pointer-events:none;width:var(--sz);height:var(--sz);transform:translate(-50%,-50%) rotate(var(--r));animation:sparkPop .7s var(--ease) forwards;}' +
    '.cur-spark::before,.cur-spark::after{content:"";position:absolute;inset:0;background:var(--clay);clip-path:polygon(50% 0,58% 42%,100% 50%,58% 58%,50% 100%,42% 58%,0 50%,42% 42%);}' +
    '.cur-spark::after{transform:scale(.5);background:#fff;}' +
    '@keyframes sparkPop{0%{opacity:0;transform:translate(-50%,-50%) rotate(var(--r)) scale(.2);}30%{opacity:1;}100%{opacity:0;transform:translate(-50%,-50%) rotate(var(--r)) scale(1.1);}}' +
    '@media (prefers-reduced-motion: reduce){.cur-spark{display:none;}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function initCursor() {
    if (!canHover() || reduce) return;
    var layer = el('div', 'cur-layer');
    document.body.appendChild(layer);
    var lastSpark = 0, lastX = innerWidth / 2, lastY = innerHeight / 2;
    function spark(x, y) {
      var s = document.createElement('span'); s.className = 'cur-spark';
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--r', (Math.random() * 90 - 45) + 'deg');
      s.style.setProperty('--sz', (5 + Math.random() * 5) + 'px');
      layer.appendChild(s); setTimeout(function () { s.remove(); }, 700);
    }
    window.addEventListener('mousemove', function (e) {
      var dist = Math.hypot(e.clientX - lastX, e.clientY - lastY), now = performance.now();
      if (dist > 6 && now - lastSpark > 55) { lastSpark = now; lastX = e.clientX; lastY = e.clientY; spark(e.clientX + (Math.random() * 14 - 7), e.clientY + (Math.random() * 14 - 7)); }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { layer.style.opacity = '0'; });
    document.addEventListener('mouseenter', function () { layer.style.opacity = '1'; });
  }

  function initTilt() {
    if (reduce || !canHover()) return;
    document.querySelectorAll('[data-bea-tilt]').forEach(function (n) {
      var max = parseFloat(n.getAttribute('data-bea-tilt')) || 7;
      n.addEventListener('mousemove', function (e) {
        var r = n.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        n.style.transform = 'perspective(800px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) scale(1)';
        n.style.setProperty('--gx', (px * 100 + 50) + '%');
      });
      n.addEventListener('mouseleave', function () { n.style.transform = 'perspective(800px) rotateY(0) rotateX(0) scale(1)'; });
    });
  }

  function initMagnetic() {
    if (reduce || !canHover()) return;
    document.querySelectorAll('[data-bea-magnetic]').forEach(function (n) {
      var s = parseFloat(n.getAttribute('data-bea-magnetic')) || 0.35;
      n.addEventListener('mousemove', function (e) {
        var r = n.getBoundingClientRect();
        n.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * s) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * s) + 'px)';
      });
      n.addEventListener('mouseleave', function () { n.style.transform = 'translate(0,0)'; });
    });
  }

  function initScrollProgress() {
    var bar = el('div'); bar.style.cssText = 'position:fixed;top:0;left:0;right:0;height:3px;z-index:60;pointer-events:none';
    var fill = el('div'); fill.style.cssText = 'height:100%;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,var(--clay),var(--rose),var(--clay-deep))';
    bar.appendChild(fill); document.body.appendChild(bar);
    function onScroll() { var h = document.documentElement.scrollHeight - innerHeight; fill.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')'; }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-bea-parallax]');
    if (!els.length) return;
    window.addEventListener('scroll', function () {
      els.forEach(function (n) {
        var sp = parseFloat(n.getAttribute('data-bea-parallax')) || 0.08;
        var r = n.getBoundingClientRect();
        n.style.setProperty('--py', (((r.top + r.height / 2 - innerHeight / 2) * -sp).toFixed(1)) + 'px');
      });
    }, { passive: true });
  }

  function init() { initCursor(); initTilt(); initMagnetic(); initScrollProgress(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
